export default __webpack_public_path__ + "static/media/image2.a7b1649a.jpg";